export default __webpack_public_path__ + "static/media/mixg day2_201103_0.c54f69bf.jpg";